import React from 'react';
import PropTypes from 'prop-types';
import { getClassName } from 'utils/ui/classes';

const XIcon = ({ className }) => (
  <svg
    className={getClassName(className)}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M6 18L18 6M6 6l12 12"
    />
  </svg>
);

XIcon.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
};

XIcon.defaultProps = {
  className: 'w-4 h-4',
};

export default XIcon;
